import { useSelector } from 'react-redux';
import * as Styled from '../../styles/UsuariosAprovados.styles';
import ImageElement from '../../../../components/ImageElement/ImageElement';
import { useEffect, useState } from 'react';

export default function DocumentCollum() {
  const { DOCUMENTOS } = useSelector((state) => state.user.usersData);
  const [selectedImage, setSelectedImage] = useState(0);
  const [imageURL, setImageURL] = useState('');

  const changeImage = (newURL, index) => {
    setSelectedImage(index);
    setImageURL(newURL);
  };

  useEffect(() => {
    DOCUMENTOS?.length > 0 && setImageURL(DOCUMENTOS[0]?.CAMINHO_ARQUIVO);
  }, []);

  return (
    <Styled.TaxaContainer>
      <Styled.TitleStyled>Documentos Anexados</Styled.TitleStyled>
      <Styled.DocContainer>
        {DOCUMENTOS?.map((documento, index) => {
          return (
            <Styled.Taxa key={index}>
              <Styled.ImageButton
                index={index}
                selectedImage={selectedImage}
                onClick={() => changeImage(documento.CAMINHO_ARQUIVO, index)}
              >
                {documento.DESCRICAO_CATEGORIA}
              </Styled.ImageButton>
            </Styled.Taxa>
          );
        })}
      </Styled.DocContainer>
      <Styled.ImageCollum>
        <ImageElement image={imageURL} />
      </Styled.ImageCollum>
    </Styled.TaxaContainer>
  );
}
